import { IAutoSaveDoc } from './../../../services/autosave/autosave.interface';
import { Component, OnInit, OnDestroy, Type, Input } from '@angular/core';
import { IModalWindow, IGetClass } from 'src/app/utils/interfaces/modal-dialog.interface';
import { ModalWindowsTypes } from 'src/app/core/enums';
import { AutosaveManagerService } from 'src/app/services/autosave/autosave-manager.service';
import { ToastrDialogService } from 'src/app/services/toastr-dialog.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ToastrActionEnum } from 'src/app/utils/enums';
import { FileRestoringService } from 'src/app/services/file-restoring.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';


@Component({
    selector: 'asg-autosave-restore-dialog',
    templateUrl: './autosave-restore-dialog.component.html',
    styleUrls: ['./autosave-restore-dialog.component.scss'],
    standalone: true,
    imports: [MatListModule, FormsModule, MatProgressSpinnerModule, TranslateModule]
})
export class AutosaveRestoreDialogComponent implements OnInit, OnDestroy, IModalWindow, IGetClass {
  @Input() unsavedFiles: IAutoSaveDoc[] | null = null;
  @Input() ok: () => void;
  selectedFiles: IAutoSaveDoc[] = [];
  restoring: boolean = false;
  constructor(
    private readonly fileRestoringService: FileRestoringService,
    private readonly autosave: AutosaveManagerService,
    private readonly translateService: TranslateService,
    private readonly toastrService: ToastrDialogService,
  ) { }

  ngOnInit(): void {
    this.selectedFiles = [];
  }

  ngOnDestroy(): void {
    this.removeUnusedFiles();
  }

  getClass(): string {
    return 'cloud-storage-dlg';
  }

  getWindowType(): Type<IModalWindow> {
    return AutosaveRestoreDialogComponent;
  }

  getWindowEnumType(): ModalWindowsTypes {
    return ModalWindowsTypes.AUTOSAVE_RESTORE_DIALOG;
  }

  getInstanceOf(type: string): IModalWindow | IGetClass | null {
    switch (type) {
      case 'IModalWindow':
        return this as unknown as IModalWindow;
      case 'IGetClass':
        return this as unknown as IGetClass;
      default: return null;
    }
  }

  setOptions(data: IAutoSaveDoc[]): void {
    this.unsavedFiles = data;
  }

  async restore(): Promise<void> {
    try {
      this.restoring = true;
      for (const e of this.selectedFiles) {
        await this.fileRestoringService.restore(e);
      }
      this.ok();
    } catch (err) {
      // this.modalService.createModalWindow(CommonMessageDialogComponent, { messageKey: 'AUTOSAVE_ERRORS.FILE_AUTORECOVER_ERROR' });
      this.toastrService.showToaster(ToastrActionEnum.Error, this.translateService.instant('AUTOSAVE_ERRORS.FILE_AUTORECOVER_ERROR'));
    } finally {
      this.restoring = false;
    }
  }

  private async removeUnusedFiles(): Promise<void> {
    if (this.unsavedFiles && this.selectedFiles.length !== this.unsavedFiles.length) {
      const unSelected = this.unsavedFiles.filter(e => {
        const selected = this.selectedFiles.find(i => e.documentHash === i.documentHash);
        return !selected;
      });
      await this.autosave.deleteFiles(unSelected);
    }
  }
}
